import React, { useState, useContext } from "react";
import { Link, withRouter, useHistory } from "react-router-dom";
import Dialog from "./dialog";
import Input from "./input";
import { setToken } from "../../utils";
import AppContext from "../../app-context";
import SearchBar from "./search-bar";
import "./head.css";
import logo from "../../images/logo.png";
import wxminiImg from "../../images/wxmini.png";
import regImg from "../../images/reg.png";
import { getAccessToken, getIdentifyCode, register } from "../../data";
import md5 from "../../md5";

let timer = null;

function Head() {
  const history = useHistory();
  const [showDialog, setShowDialog] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [checked, setChecked] = useState(true);
  const [registerLoading, setRegisterLoading] = useState(false);

  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const captchaAppId = "2014014128";
  const [time, setTime] = useState(0);

  const appCtx = useContext(AppContext);

  function handleCloseWxminiDialog() {
    if (registerLoading) return;
    setShowDialog(false);
    setCode("");
    setPhone("");
    cleanT();
    setTime(0);
  }

  function onShowWxminiDialog() {
    setShowDialog(true);
  }

  function gotoOrders() {
    if (appCtx.loadedAuth !== true) return;
    if (appCtx.isLogin !== true) {
      appCtx.openAuthDialog();
      return;
    }
    history.push(`/orders`);
  }

  function handleLogout() {
    setToken("");
    appCtx.logout();
  }

  function onLogin() {
    setShowLoginDialog(true);
  }

  function handleCloseLoginDialog() {
    if (loginLoading) return;
    setShowLoginDialog(false);
    setCode("");
    setPhone("");
    cleanT();
    setTime(0);
  }

  function handleLogin() {
    if (!phone) {
      alert("请输入手机号");
      return;
    }

    if (/^1[0-9]{10}$/.test(phone) === false) {
      alert("请输入正确的手机号");
      return;
    }

    if (!code) {
      alert("请输入验证码");
      return;
    }

    if (loginLoading) return;
    setLoginLoading(true);

    getAccessToken(phone, code).then((res) => {
      setLoginLoading(false);
      if (res && res.access_token) {
        setToken(res.access_token);
        setTimeout(() => {
          window.location.reload();
        }, 0);
      } else {
        alert("登录失败");
      }
    });
  }

  function cleanT() {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
  }

  function couTime(t) {
    cleanT();
    setTime(t);
    if (t <= 0) {
      cleanT();
      return;
    } else {
      timer = setTimeout(() => {
        couTime(t - 1);
      }, 1000);
    }
  }

  function callbackCaptcha(res) {
    if (res && res.ret === 0) {
      const query = {
        phone,
        type: 5,
        ticket: res.ticket,
        randstr: res.randstr,
        captchaAppId,
      };
      getIdentifyCode(query).then((res) => {
        if (res && res.recode === 200) {
          couTime(60);
        } else {
          alert("未注册或验证码错误");
        }
      });
    }
  }

  function onCaptchaShow() {
    if (time > 0) return;
    if (!phone) {
      alert("请输入手机号");
      return;
    }

    if (/^1[0-9]{10}$/.test(phone) === false) {
      alert("请输入正确的手机号");
      return;
    }
    try {
      // 生成一个验证码对象
      // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
      // callback：定义的回调函数
      const captcha = new window.TencentCaptcha(
        captchaAppId,
        callbackCaptcha,
        {}
      );
      // 调用方法，显示验证码
      captcha.show();
    } catch (error) {
      // 加载异常，调用验证码js加载错误处理函数
    }
  }

  function handleRegister() {
    setShowLoginDialog(false);
    setCode("");
    cleanT();
    setTime(0);
    onShowWxminiDialog();
  }

  function onChecked() {
    setChecked(!checked);
  }

  function callbackCaptchaRegister(res) {
    if (res && res.ret === 0) {
      const query = {
        phone,
        type: 1,
        ticket: res.ticket,
        randstr: res.randstr,
        captchaAppId,
      };
      getIdentifyCode(query).then((res) => {
        if (res && res.recode === 200) {
          couTime(60);
        } else {
          alert("验证码失败");
        }
      });
    }
  }

  function onGetRegisterCode() {
    if (time > 0) return;
    if (!phone) {
      alert("请输入手机号");
      return;
    }

    if (/^1[0-9]{10}$/.test(phone) === false) {
      alert("请输入正确的手机号");
      return;
    }

    try {
      // 生成一个验证码对象
      // CaptchaAppId：登录验证码控制台，从【验证管理】页面进行查看。如果未创建过验证，请先新建验证。注意：不可使用客户端类型为小程序的CaptchaAppId，会导致数据统计错误。
      // callback：定义的回调函数
      const captcha = new window.TencentCaptcha(
        captchaAppId,
        callbackCaptchaRegister,
        {}
      );
      // 调用方法，显示验证码
      captcha.show();
    } catch (error) {
      // 加载异常，调用验证码js加载错误处理函数
    }
  }

  function handleDoRegister() {
    if (!checked) {
      alert("请勾选用户协议和隐私协议");
      return;
    }

    if (!customerName) {
      alert("请输入企业名");
      return;
    }

    if (!phone) {
      alert("请输入手机号");
      return;
    }

    if (/^1[0-9]{10}$/.test(phone) === false) {
      alert("请输入正确的手机号");
      return;
    }

    if (!code) {
      alert("请输入验证码");
      return;
    }

    if (registerLoading) return;
    setRegisterLoading(true);

    const body = {
      type: 0, //  五金店
      phone,
      pwd: md5(code),
      code,
      customerName: customerName,
      name: customerName,
    };

    register(body).then((res) => {
      if (res && res.recode === 200) {
        appCtx.openAuthDialog("注册成功");
      } else {
        alert("注册失败");
      }
      setRegisterLoading(false);
      handleCloseWxminiDialog();
    });
  }

  return (
    <>
      <div className="header">
        <div className="mod-box">
          <Link to="/">
            <img className="logo" src={logo} />
          </Link>
          {/* <div className="item">
          <Link className="inner" to="/">首页</Link>
        </div>
        <div className="item">
          <Link className="inner" to="/about">关于纵购</Link>
          <div className="drop-down">
            <Link className="entry" to="/about">纵购简介</Link>
            <Link className="entry" to="/operation">运营中心</Link>
            <Link className="entry" to="/project">项目介绍</Link>
          </div>
        </div>
        <div className="item">
          <Link className="inner" to="/brand">品牌中心</Link>
        </div>
        <div className="item">
          <Link className="inner" to="/data/car">运营规模</Link>
          <div className="drop-down">
            <Link className="entry" to="/data/car">车辆及路线</Link>
            <Link className="entry" to="/data/area">运营中心仓储面积</Link>
            <Link className="entry" to="/data/user">客户资源及分布情况</Link>
          </div>
        </div>
        <div className="item">
          <Link className="inner" to="/join">招商加盟</Link>
          <div className="drop-down">
            <Link className="entry" to="/join">战略合作</Link>
            <Link className="entry" to="/business">供应商合作</Link>
          </div>
        </div>
        <div className="item">
          <Link className="inner" to="/contact">联系我们</Link>
        </div>
        <div className="item">
          <a className="inner" href="/appdowns">下载APP</a>
        </div> */}
          <SearchBar></SearchBar>
          <div className="nav-menu">
            {!appCtx.isLogin && appCtx.loadedAuth ? (
              <>
                <span className="nav-item" onClick={onShowWxminiDialog}>
                  免费注册
                </span>
                <span className="nav-item" onClick={onLogin}>
                  登录
                </span>
              </>
            ) : null}
            {appCtx.isLogin && appCtx.loadedAuth ? (
              <div className="nav-item nav-item-user">
                {appCtx.user.name}(<span onClick={handleLogout}>退出</span>)
              </div>
            ) : null}
            <span className="nav-item" onClick={gotoOrders}>
              我的订单
            </span>
          </div>
        </div>
      </div>
      {/* <Dialog
        className="wxmini-dialog"
        show={showDialog}
        okText=""
        cancelText=""
        onClose={handleCloseWxminiDialog}
      >
        <div className="fix">
          <img className="fl-l" src={regImg} width={300} height={320} />
          <div style={{ paddingLeft: 310 }}>
            <img src={wxminiImg} width={280} height={280} />
            <p style={{ marginTop: 10 }}>请打开微信扫一扫进行注册</p>
          </div>
        </div>
      </Dialog> */}
      <Dialog
        className="registerUser-dialog"
        show={showDialog}
        okText="注册"
        onOk={handleDoRegister}
        onClose={handleCloseWxminiDialog}
        onCancel={handleCloseWxminiDialog}
      >
        <div className="fix" style={{ marginTop: 20 }}>
          <div className="fl-l" style={{ width: 70, lineHeight: "36px" }}>
            企业名：
          </div>
          <div className="fl-r">
            <Input
              placeholder=""
              maxLength={20}
              value={customerName}
              onChange={setCustomerName}
              style={{ width: 290 }}
            />
          </div>
        </div>
        <div className="fix" style={{ marginTop: 10 }}>
          <div className="fl-l" style={{ width: 70, lineHeight: "36px" }}>
            手机号：
          </div>
          <div className="fl-r">
            <Input
              placeholder=""
              maxLength={11}
              value={phone}
              onChange={setPhone}
              style={{ width: 290 }}
            />
          </div>
        </div>
        <div className="fix" style={{ marginTop: 10, paddingBottom: 10 }}>
          <div className="fl-l" style={{ width: 70, lineHeight: "36px" }}>
            验证码：
          </div>
          <div className="fl-r">
            <Input
              placeholder=""
              maxLength={8}
              value={code}
              onChange={setCode}
              style={{ width: 150 }}
            />
            <span className="login-code-btn" onClick={onGetRegisterCode}>
              {time > 0 ? `(${time}秒后重新获取)` : "获取验证码"}
            </span>
          </div>
        </div>
        <div>
          <input
            type="checkbox"
            checked={checked}
            autoComplete="off"
            onChange={onChecked}
          />
          <span style={{ marginLeft: 6 }}>
            已阅读并同意以下协议{" "}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://static.ourchoice.cn/h5/public/agreement.html?app=1"
              style={{ textDecoration: "underline" }}
            >
              《用户协议》
            </a>
            、
            <a
              target="_blank"
              rel="noreferrer"
              href="https://static.ourchoice.cn/h5/public/privacy.html?app=1"
              style={{ textDecoration: "underline" }}
            >
              《隐私协议》
            </a>
          </span>
        </div>
      </Dialog>
      <Dialog
        className="login-dialog"
        show={showLoginDialog}
        onClose={handleCloseLoginDialog}
        onOk={handleLogin}
        onCancel={handleCloseLoginDialog}
      >
        <div className="fix" style={{ marginTop: 20 }}>
          <div className="fl-l" style={{ width: 70, lineHeight: "36px" }}>
            手机号：
          </div>
          <div className="fl-r">
            <Input
              placeholder=""
              maxLength={11}
              value={phone}
              onChange={setPhone}
              style={{ width: 250 }}
            />
          </div>
        </div>
        <div className="fix" style={{ marginTop: 10, paddingBottom: 10 }}>
          <div className="fl-l" style={{ width: 70, lineHeight: "36px" }}>
            验证码：
          </div>
          <div className="fl-r">
            <Input
              placeholder=""
              maxLength={8}
              value={code}
              onChange={setCode}
              style={{ width: 110 }}
            />
            <span className="login-code-btn" onClick={onCaptchaShow}>
              {time > 0 ? `(${time}秒后重新获取)` : "获取验证码"}
            </span>
          </div>
        </div>
        <div style={{ paddingLeft: 70 }}>
          <span className="login-register" onClick={handleRegister}>
            我要注册
          </span>
        </div>
      </Dialog>
    </>
  );
}

export default withRouter(Head);
